/*
 * Copyright (c) 2013, Divio AG
 * Licensed under BSD
 * http://github.com/divio/djangocms-boilerplate-webpack
 */

import $ from 'jquery'

/**
 * Localstorage shim from Modernizr
 *
 * @property {Boolean} isStorageSupported localstorage availability
 */
export const isStorageSupported = /* #__PURE__ */ (function localStorageCheck() {
  const mod = 'modernizr'

  try {
    localStorage.setItem(mod, mod)
    localStorage.removeItem(mod)
    return true
  } catch (e) {
    return false
  }
})()

/**
 * Simple redirection
 *
 * @method redirectTo
 * @param {String} url - URL string
 */
export function redirectTo(url) {
  window.location.href = url
}

/**
 * if you refresh the markup via innerHTML, svgs won't show anymore
 *
 * @public
 * @param {jQuery} elem where to look for svgs
 */
export function refreshSVG(elem) {
  elem.find('svg').each((i, el) => {
    $(el).replaceWith($(el).clone().wrap('<div></div>').parent().html())
  })
}

/**
 * Save information within local storage
 *
 * @method setStorage
 * @param {String} token - namespace
 * @param {String} value - storage value
 * @returns {Boolean|String} item value or negative result
 */
export function setStorage(token, value) {
  if (token && value && isStorageSupported) {
    localStorage.setItem(token, value)
    return value
  }
  return false
}

/**
 * Retrieve information from local storage
 *
 * @method getStorage
 * @param {String} token - namespace
 * @return {String|Boolean} localStorage item or negative result
 */
export function getStorage(token) {
  if (token && isStorageSupported) {
    return localStorage.getItem(token)
  }
  return false
}

export function scrollTo(position, speed = 200) {
  return new Promise((resolve) => {
    $('html, body').animate(
      {
        scrollTop: position
      },
      speed,
      resolve
    )
  })
}
